import { render, staticRenderFns } from "./catalog-section.vue?vue&type=template&id=73cb505c&"
import script from "./catalog-section.vue?vue&type=script&lang=js&"
export * from "./catalog-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports